import React from 'react';
import {Route, Switch} from 'react-router-dom';
import RaisedButton from 'material-ui/RaisedButton';
import * as firebase from 'firebase';
import Promo from '../../components/Promo';

/**
 * This file holds content (and container/routing) for each of the promos.
 */
// const getMailtoLink = (title) => `mailto:sales@screen6.io?subject=${encodeURIComponent('Client console - ' + title)}`;
const getFormLink = (title) => {
  let
    client = capitalizeFirstLetter(firebase.auth().currentUser.s6client),
    email = firebase.auth().currentUser.email;

  title = encodeURIComponent(title);
  return `https://docs.google.com/forms/d/e/1FAIpQLSeRkF33o0OYPNpviNjqtQAzApltIX_wh_7ETheGf9_fp8h3gQ/viewform?usp=pp_url&entry.1066526710=${client}&entry.2072515663=${email}&&entry.1572047655=${title}`;
}

function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

const PromoAmp = () => (
  <Promo
    title="Amplification service"
    subtitle="Amplify your audience"
    sideContent={<p><img alt="" src="/media/images/promo/Screen6_HubGraphics_audience_amplification.png" /></p>}
  >
    <h3>Quickly create amplified audience segments based on device preferences.</h3>
    <p>
      Based on your own pre-defined audience quickly build amplified ones. Jump from one device type to the other - 
      targeting the same user seamlessly across channels by simply uploading an existing segment as a file, URL, 
      or text and selecting which device type to include in the new, amplified export file. 
    </p>

    <h3>Get immediate insights with amplification rates.</h3>
    <p>
      Use Screen6 Audience Amplification to gain immediate insights in the amplification rate of your audience. 
      Discover the many opportunities which were previously overlooked and not associated with your segment, 
      and estimate how this influences your KPI’s.
    </p>

    <br/>

    <RaisedButton primary={true} href={getFormLink('AMPLIFICATION SERVICE')} target="_blank"
      label="Request access"/>
  </Promo>
)

const PromoLoc = () => (
  <Promo
    title="POI Audience"
    subtitle="Understand the full picture with analytics on your users offline behaviors and activate across all channels."
    sideContent={<p><img alt="" src="/media/images/promo/Screen6_HubGraphics_poi.png" /></p>}
  >
    <h3>Understand the full picture with analytics on your users’ offline behaviors.</h3>
    <p>
     Regardless of your touchpoints with your users - on desktop, OTT, or some other digital channel - leverage the 
      Screen6 Hub’s POI Audience tool to get a clear understanding of each of your user’s geographical travel behaviors, 
      brand affiliations, OOH exposure, and much more. Let Screen6 leverage its partnerships with various location data
      providers to match your users with their historical and real-time location to better understand where your users 
      have been, currently are, and where they might be going before, during, and after they interact with your ads. 
  </p>

    <h3>Build location specific audiences for targeting across all channels.</h3>
    <p>
    Given the flexibility of the POI Audiences’ tool within the Screen6 Hub, marketers have the ability to activate the 
      audiences across all channels. While the location data is derived from historical data gathered from partners 
      and normalized in association with your private graph, it is able to be exported in association with IDs 
      encapsulating desktop cookies, OTT devices, and the like. 
   </p>

    <br />
    <RaisedButton primary={true} href={getFormLink('POI AUDIENCE')} target="_blank" label="Request access"/>
  </Promo>
)

const PromoStoreVisitation = () => (
  <Promo
    title="Cross Channel Store Visitation Rate"
    subtitle="Explore the effect each digital media channel has on consumers’ offline behavior. "
    sideContent={<p><img alt="" src="/media/images/promo/Screen6_HubGraphics_store_visitations.png" /></p>}
  >
    <h3>Provide offline measurement of your digital media efforts to prove ROAS. </h3>
    <p>
      Post-campaign measurement and appropriate attribution has always ensured continued investment from clients. 
      With constant testing of new strategies and extension to new channels it is imperative to show direct 
      correlation between your client’s marketing spend and their bottom line. Connecting the physical and digital 
      world allows for campaign performance to be tied to offline conversions through store visits. 
    </p>

    <h3>Quantify your efforts across OTT with measurement of in-store visits. </h3>
    <p>
      TV advertising has always been assumed to impact consumer behavior - especially in the offline world. With
      Screen6’s ability to tie individuals’ digital identities across all connected devices, including OTT, as well as
      their collective associations to Advanced Households marketers can now understand how their efforts across
      connected TV impact buying decisions at the same granular level as their traditional media buys. Utilize Screen6’s
      Cross Channel SVR reporting within The Hub to identify whether exposure to a TV commercial affects a user’s
      real-world behavior.
    </p>

    <br />
    <RaisedButton primary={true} href={getFormLink('CROSS CHANNEL STORE VISITATION RATE')} target="_blank"
      label="Request access"/>
  </Promo>
)

const PromoCrm = () => (
  <Promo
    title="CRM Onboarding at Scale"
    subtitle="Sync your data with PII providers IDs ensuring the highest match rate."
    sideContent={<p><img alt="" src="/media/images/promo/Screen6_HubGraphics_crm_onboarding.png" /></p>}
  >
    <h3>Traditional CRM Onboarding enables advertisers to find its offline audience in the digital world. </h3>
    <p>
      CRM onboarding is an established practice within digital advertising. Offline consumer records are used to
      identify a digital audience for use during a campaign. The process entails the advertiser to upload its CRM 
      database to be compared with the provider of match data between Personally Identifiable Information (PII) and 
      pseudonymous identifiers (i.e. cookies and device IDs).
    </p>

    <h3>
      Screen6 enables direct syncs between PII providers and the pseudonymous IDs already included in your private
      graph.
    </h3>
    <p>
  The challenged faced by most CRM onboarding vendors is the ability to scale - vendors are limited by the amount of PII 
      they have tied to targetable, pseudonymous identifiers (of which not all of them are available for targeting in 
      the platform’s cross-device graph). The issue is not the number of PII records they have under management, but 
      the lack of understanding that multiple pseudonymous IDs belong to the same individual. Screen6’s CRM 
      Onboarding capabilities, as part of The Hub, solve this challenge. 
    </p>

    <br />
    <RaisedButton primary={true} href={getFormLink('CRM ONBOARDING AT SCALE')} target="_blank" label="Request access"/>
  </Promo>
)

const PromoGrapeshot = () => (
  <Promo
    title="Grapeshot Audience Segmentation"
    subtitle="Leverage Grapeshot’s keyword technology to segment your audience based on their cross-device behavior."
    sideContent={<p><img alt="" src="/media/images/promo/Screen6_HubGraphics-grapeshot.png" /></p>}
  >
    <h3>Stop relying on static, outdated lists.</h3>
    <p>
      Grapeshot, the market leader in contextual marketing, weights words and phrases in real-time to identify the 
      significant signal in any document. Grapeshot’s adaptive machine learning algorithms within WordRank™ power 
      automated page classification system.
    </p>

    <h3>Instantly identify new audiences for your content based on cross-device browser behavior.</h3>
    <p>
      The Grapeshot keyword technology and language based capabilities in conjunction with your Screen6 graph will allow
      to more precisely aggregate and contextualize audience segments based on language and produces true audience 
      profiles for multiple URLs. Activation is simple with the addition of one additional attribute per Event in the
      data file your platform passes Screen6 for processing: URL. 
    </p>

    <br />
    <RaisedButton primary={true} href={getFormLink('GRAPESHOT AUDIENCE SEGMENTATION')} target="_blank"
      label="Request access"/>
  </Promo>
)

const PromoHouseholding = () => (
  <Promo
    title="Advanced Householding"
    subtitle="Enable targeting at the household level while eliminating waste."
    sideContent={<p><img alt="" src="/media/images/promo/Screen6_HubGraphics_household.png" /></p>}
  >
    <h3>Eliminate waste associated with traditional householding.</h3>
    <p>
      Advanced Householding eliminates waste associated with traditional household targeting tools, which target 
      individual IP addresses assuming they represent a static postal address. Screen6 technology recognizes that 
      IP addresses aren’t static and that there’s a dynamic relationship between multiple devices. 
    </p>

    <h3>Enable targeting at the household level.</h3>
    <p>
      Advanced Householding combines user-identification techniques such as intra-device connectivity, location, and
      usage patterns to track and cluster groups of connected devices with similar behaviors. By recognizing the devices
      that don’t fully align to a single individual’s behavior, Screen6 is able to assign these shared devices - 
      such as a tablet, PC, OTT, etc. - to a family or household. Household IDs enable clients to individually target 
      users within a household through existing cross-device features, or target the whole household.    </p>

    <br />
    <RaisedButton primary={true} href={getFormLink('ADVANCED HOUSEHOLDING')} target="_blank" label="Request access"/>
  </Promo>
)

const PromoTrueReach = () => (
  <Promo
    title="Campaign Analytics &amp; Reporting"
    subtitle="Access campaign-level analytics and reporting representing TrueReach™ and frequency at the individual level."
    sideContent={<p><img alt="" src="/media/images/promo/Screen6_HubGraphics_analytics.png"/></p>}
  >
    <h3>Gain TrueReach™ and True Frequency campaign insights.</h3>
    <p>
      Let Screen6 do the heavy lifting. The Hub provides campaign-level analytics and reporting functionality with true
      cross-device capabilities so the statistics generated are de-duplicated and represent people-based frequency
      metrics. Screen6 acts as your daily source for incremental reach and frequency data so you can monitor your
      campaign in a centralized Hub.
    </p>

    <h3>Work within the Hub or build your own interface with our API.</h3>
    <p>
      Work with the Screen6 team to determine the delivery method of the processed output data: either through a The Hub
      interface or by accessing our API. The interface shows daily and incremental data, while the API outputs similar
      information in real time.
    </p>

    <br />
    <RaisedButton primary={true} href={getFormLink('CAMPAIGN ANALYTICS & REPORTING')} target="_blank"
      label="Request access" />
  </Promo>
)

const PromoGraphExpansion = () => (
  <Promo
    title="Graph Expansion"
    subtitle="Expand the reach of your graph beyond your own dataset through Screen6’s strategic partners."
    sideContent={
      <p>
        <img alt="" src="/media/images/promo/Screen6_HubGraphic_GraphExpansion_400x320.png"/>
      </p>
    }
  >
    <h3>Bring Your Own Data (BYOD) to Screen’s Hub to ensure data protection.</h3>
    <p>
      Screen6 builds private identity graphs working with each client’s dataset in a complete silo in order to stop data
      leakage into the ecosystem which may be used to benefit a competitor. As such, some platforms might benefit from
      the inclusion of supplemental data to fill the holes in their own dataset or to expand beyond the channels in
      which they currently transact. 
    </p>

    <h3>Expand your dataset while maintaining your data’s integrity.</h3>
    <p>
      Screen6’s privacy compliant approach allows clients to maintain data rights and ownership of their datasets. The
      ability to incorporate complementary data from Airpush, Kochava, and ShareThis across desktop and in-app
      environments allow platforms to expand their cross-device understanding, audience segmentation, targeting,
      analytics, and attribution capabilities. Work with Screen6 and its strategic partners to understand how their data
      will complement your existing graph, the scale increase you should expect, and how it will benefit your business
      as a whole.
    </p>

    <br />
    <RaisedButton primary={true} href={getFormLink('GRAPH EXPANSION')} target="_blank"
      label="Request access" />
  </Promo>
)

const Promos = () => (
  <Switch>
    <Route path="/explore/amp" component={PromoAmp} />
    <Route path="/explore/poi" component={PromoLoc} />
    <Route path="/explore/store_visitation" component={PromoStoreVisitation} />
    <Route path="/explore/crm_onboarding" component={PromoCrm} />
    <Route path="/explore/partner_grapeshot" component={PromoGrapeshot} />
    <Route path="/explore/householding" component={PromoHouseholding} />
    <Route path="/explore/truereach" component={PromoTrueReach} />
    <Route path="/explore/graph_expansion" component={PromoGraphExpansion} />
  </Switch>
)

export default Promos;



// WEBPACK FOOTER //
// ./src/containers/Promos/index.jsx